import { Dispatch } from 'redux';
import type { WModuleGroupViewList } from '@zola/svc-web-api-ts-client';
import { getModuleGroupsList } from '../client/v1/moduleGroups';
import * as MegaMenusConstants from '../util/constants/megaMenuModuleGroups';
import * as ActionTypes from './types/ModuleGroupActionTypes';

const defaultModuleGroups = [
  MegaMenusConstants.MEGA_MENU_REGISTRY,
  MegaMenusConstants.MEGA_MENU_PAPER,
  MegaMenusConstants.MEGA_MENU_WEBSITE,
  MegaMenusConstants.MEGA_MENU_WEBSITE_LARGE,
  MegaMenusConstants.MEGA_MENU_GUEST_LIST,
  MegaMenusConstants.MEGA_MENU_BOUTIQUE,
  MegaMenusConstants.MEGA_MENU_VENDORS,
  MegaMenusConstants.MEGA_MENU_ADVICE,
  MegaMenusConstants.MEGA_MENU_ALBUMS,
  MegaMenusConstants.MEGA_MENU_ALBUMS_LARGE,
];

function requestModuleGroups(): ActionTypes.ModuleGroupActionTypes {
  return {
    type: ActionTypes.REQUEST_MODULE_GROUP,
  };
}

function receiveModuleGroups(data: WModuleGroupViewList): ActionTypes.ModuleGroupActionTypes {
  return {
    type: ActionTypes.RECEIVE_MODULE_GROUP,
    payload: data,
  };
}

export function fetchModuleGroups(tags = defaultModuleGroups) {
  return (dispatch: Dispatch<ActionTypes.ModuleGroupActionTypes>): Promise<void> => {
    dispatch(requestModuleGroups());
    return getModuleGroupsList(tags).then((json) => {
      dispatch(receiveModuleGroups(json));
    });
  };
}
